import * as React from "react";
import SuccessStoriesSvg from "../../../assets/svg/background.svg"; // Assuming your image path
import Person from "../../../assets/svg/person.svg";
import Star from "../../../assets/svg/star.svg";
import Clouds from "../../../assets/svg/clouds.svg";
import { useNavigate } from "react-router-dom";
import styles from "./Banner.scss";
import { motion } from "framer-motion";

const Banner = ({ isButtonShown = false }) => {
    const navigate = useNavigate();
    const imagesRef = React.useRef([]);

    const [isInView, setIsInView] = React.useState(false);
    const myRef = React.useRef(null);

    const addActiveClassWithDelay = (isVisible) => {
        if (isVisible) {
            imagesRef.current.forEach((image, index) => {
                setTimeout(
                    () => {
                        if (image) {
                            image.classList.add("active");
                        }
                    },
                    (index + 1) * 1000
                ); // Delay for each image by index * 1000 ms
            });
        }
    };

    React.useEffect(() => {
        // Function to add the 'active' class to each image with a delay

        const observer = new IntersectionObserver(
            ([entry]) => {
                addActiveClassWithDelay(entry.isIntersecting);
            },
            {
                root: null, // Use the viewport as the container
                rootMargin: "0px",
                threshold: 0.1, // Trigger when 10% of the element is visible
            }
        );

        if (myRef.current) {
            observer.observe(myRef.current);
        }

        return () => {
            if (myRef.current) {
                observer.unobserve(myRef.current);
            }
        };
    }, [myRef]);
    return (
        <motion.section
            initial={{ opacity: 0, translateY: -100 }}
            whileInView={{ opacity: 1, translateY: 0 }}
            transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
            viewport={{ once: true }}
            ref={myRef}
            className="flex flex-col justify-center self-stretch w-full max-md:mt-10 max-md:max-w-full"
        >
            <div className="flex overflow-hidden relative flex-col justify-center items-center px-2 md:px-16 py-14 w-full md:min-h-[512px]">
                <img
                    alt="Background Image"
                    src={SuccessStoriesSvg}
                    className="object-cover absolute inset-0 size-full"
                />
                <div className="relative w-full container">
                    <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                        <div className="flex flex-col w-full sm:w-[67%] max-md:ml-0 max-md:w-full">
                            <div className="flex relative gap-3.5 items-start mt-5 text-white max-md:flex-wrap max-md:mt-10">
                                <div className="flex flex-col grow shrink-0 self-end mt-6 w-fit max-md:max-w-full">
                                    <h2 className="text-3xl sm:text-5xl font-medium capitalize max-md:max-w-full">
                                        Pioneering the way forward to better decision making
                                    </h2>
                                    <p className="mt-5 text-lg max-md:max-w-full">
                                        Expert knowledge and market insights into any industry in
                                        every corner of the world
                                    </p>
                                    {
                                        isButtonShown && (
                                            <button
                                                className="justify-center self-center px-16 py-5 mt-20 text-2xl text-center rounded-lg  shadow-xl max-md:px-6 max-md:mt-10 dark-button"
                                                onClick={() => (window.location.href = "/success-stories")}>
                                                Read More
                                            </button>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
                            <div className="banner-image-stack">
                                <img
                                    src={Clouds}
                                    alt="Clouds"
                                    className="banner-stacked-image"
                                    ref={(el) => (imagesRef.current[0] = el)}
                                />
                                <img
                                    src={Person}
                                    alt="Person"
                                    className="banner-stacked-image"
                                    ref={(el) => (imagesRef.current[1] = el)}
                                />
                                <img
                                    src={Star}
                                    alt="Stars"
                                    className="banner-stacked-image"
                                    ref={(el) => (imagesRef.current[2] = el)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </motion.section>
    );
};

export default Banner;
